import { CustomerType } from '@repo/common';
import { Button } from '@repo/shadcn';
import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';

import { CustomerTypeBadge, PaymentStatusBadge } from '@/components/ui/badge';
import { Route } from '@/constants';
import { OrderListItemSchemaType } from '@/features/slice/order/order.schema';
import { formatCurrencyInBDT } from '@/utils/currency-formater';

export const orderListColumns: ColumnDef<OrderListItemSchemaType>[] = [
    {
        accessorKey: 'invoice_number',
        header: () => {
            return <div>Invoice Number</div>;
        },
        cell: ({ row }) => (
            <div className="font-medium">
                <Link
                    to={`${Route.SALES}/${row.original.id}`}
                    className="cursor-pointer transition-all duration-150 hover:underline"
                >
                    {/* <Button type="button" variant="link"> */}
                    {row.original.invoice_number}
                    {/* </Button> */}
                </Link>
            </div>
        ),
    },

    {
        accessorKey: 'customer_id',
        header: () => <div>Customer Name</div>,
        cell: ({ row }) => {
            if (!row.original.customer) {
                return (
                    <div className="cursor-not-allowed font-medium">
                        Walk-In Customer
                    </div>
                );
            }

            let customerPath = `${Route.CUSTOMERS}/${row.original.customer?.id}`;

            if (
                row.original.customer?.customer_type === CustomerType.WHOLESALE
            ) {
                customerPath = `${Route.WHOLESALE_ORDER_CUSTOMERS}/${row.original.customer?.id}`;
            }

            return (
                <div className="font-medium">
                    <Link
                        to={customerPath}
                        className="cursor-pointer transition-all duration-150 hover:underline"
                    >
                        {row.original.customer?.name}
                    </Link>
                </div>
            );
        },
    },
    {
        accessorKey: 'customer_type',
        header: () => <div>Order Type</div>,
        cell: ({ row }) => (
            <div className="font-medium">
                <CustomerTypeBadge
                    value={row.original.customer?.customer_type ?? 'walk-in'}
                />
            </div>
        ),
    },
    {
        accessorKey: 'date',
        header: () => <div>Date</div>,
        cell: ({ row }) => (
            <div className="font-medium">
                {format(row.original.created_at, 'dd/MM/yyyy')}
            </div>
        ),
    },

    {
        accessorKey: 'payment_status',
        header: () => <div>Status</div>,
        cell: ({ row }) => (
            <div className="">
                <PaymentStatusBadge
                    status={row.original.payment?.status ?? undefined}
                />
            </div>
        ),
    },

    {
        accessorKey: 'total_price',
        header: () => <div className="text-right">Total Price</div>,
        cell: ({ row }) => (
            <div className="text-right">
                {formatCurrencyInBDT(row.original.payment?.total_price || 0)}
            </div>
        ),
    },

    {
        accessorKey: 'total_paid',
        header: () => <div className="text-right">Total Paid</div>,
        cell: ({ row }) => (
            <div className="text-right">
                {formatCurrencyInBDT(row.original.payment?.total_paid || 0)}
            </div>
        ),
    },

    {
        accessorKey: 'total_due',
        header: () => <div className="text-right">Due</div>,
        cell: ({ row }) => (
            <div className="text-right">
                {formatCurrencyInBDT(row.original.payment?.total_due || 0)}
            </div>
        ),
    },

    {
        accessorKey: 'estimated_profit_margin',
        header: () => <div className="text-right">Profit (Est.)</div>,
        cell: ({ row }) => (
            <div className="text-right">
                {formatCurrencyInBDT(
                    row.original.payment?.estimated_profit_margin || 0,
                )}
            </div>
        ),
    },

    {
        accessorKey: 'action',
        header: () => <div className="text-right">Action</div>,
        cell: ({ row }) => (
            <div className="flex justify-end">
                <Link to={`${Route.SALES}/${row.original.id}`}>
                    <Button type="button" size="sm" variant="outline">
                        View Details
                    </Button>
                </Link>
            </div>
        ),
    },
];
